export enum MarketEnum{
    NORWAY = "1",
    CEKURA = "2",
    SAFECALL = "3",
    SWEDEN = "4",
    ICELAND = "5",
  }
